/* unplugin-vue-components disabled */import script from "./DomainDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DomainDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./DomainDrawer.vue?vue&type=style&index=0&id=7d994307&scoped=true&lang=less"
import "./DomainDrawer.vue?vue&type=style&index=1&id=7d994307&lang=css"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d994307"]])

export default __exports__